import axios from "../axios";

export type OAuthToken = {
  id: string;
  user_id?: number;
  client_id?: string;
  name?: string;
  scopes?: string[];
  revoked?: boolean;
  created_at?: string;
  updated_at?: string;
  expires_at?: string | null;
  [key: string]: unknown;
};

export async function listOAuthTokens(signal?: AbortSignal) {
  // Laravel Passport built-in endpoint returns an array.
  return (await axios.get<OAuthToken[]>("/api/v1/oauth/tokens", { signal }))
    .data;
}

export async function deleteOAuthToken(id: string, signal?: AbortSignal) {
  await axios.delete(`/api/v1/oauth/tokens/${id}`, { signal });
}
